import React, { useEffect, useState } from "react";
import "../components/styles/TodoList.css";
import Action from "../components/Action";
import LoadSimple from "../components/LoadSimple";
import Search from "../components/generales/Search";
import { lang } from "../components/generales/traduction";
import { useFetch } from "../hooks/useFetch";
import { capitalizeFirstLetter } from "../utils/utils";
// import RowProblem from "../components/monitor-components/Events/RowProblem";
import RowProblem from "../components/RowProblem";
import Paginador from "../components/generales/Paginador";
import Modal, { modalPropTypes } from "rsuite/esm/internals/Overlay/Modal";
import ModalAddProblem from "../components/monitor-components/ModalAddProblem";
import { useNavigate } from 'react-router-dom';
import LoadAlerts from "../components/LoadAlerts";
import TableEvents from "../components/monitor-components/Events/TableEvents";
const addHostModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'80%',
      height:'85%',
      padding:'20px'
    },
  };
const TodoList = ({
  onLogin,
  msgErrorLogin,
  setMsgErrorLogin,
  token,
  setToken,
  userData,
  setUserData,
  server,
}) => {
  const [infoPopup, setInfoPopup] = useState({
      message: "",
      title: "",
      submsg: "",
      type: false,
    });
  const [showPopup, setShowPopup] = useState(false);
  const handleShowPopup = (title, message, submsg, type) => {
      setInfoPopup({
        message: message,
        title: title,
        submsg: submsg,
        type: type,
      });
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 10000);
    };

  const [languaje,setLanguaje]=useState('es');
  //  
  const token_item=localStorage.getItem('access_token')
  const dataAgencies=useFetch('cassia/exception_agencies','',token_item,'GET',server)
  const dataCriticalities=useFetch('cassia/criticalities','',token_item,'GET',server)
  //  const todoListnfo=useFetch('cassia/user/to_do_events/1/get_events','',token_item,'GET',server)
  const [todoListnfo,setTodoListnfo]=useState({data:[],loading:false,error:""})
  const [allSelected, setAllSelected] = useState(false)
  const [attrSelected,setAttrSelected]=useState('')
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [orderAsc,setOrderAsc]=useState(true)
  var dataList=(searchTerm==='')?(todoListnfo.data):searchResults;
  const contOrigen = dataList.filter(elemento => elemento.tipo === 1).length;
  const contZabbix = dataList.length;
  const contProblem = dataList.filter(elemento => elemento.Estatus === 'PROBLEM').length;
  const contResolved = dataList.filter(elemento => elemento.Estatus === 'RESOLVED').length;
  const [userPermissions, setUserPermissions] = useState([]);
  const [mode, setMode] = useState("");
  const [titleHead,setTitleHead]=useState(lang[languaje]['inicio'])
  // console.log("main -----------"+pageSelected)
  useEffect(() => {
  try {
    let userSession = JSON.parse(localStorage.getItem("user_session"));

    const expirationDate = new Date(userSession.refresh_token_expires);
    const currentDate = new Date();

    getPermisos(userSession.roles[0].rol_id);
    // setRolID(userSession.roles[0].rol_id);
    
  } catch (error) {
    
    onLogin(false);
    localStorage.setItem(
      "MsgErrorLogin",
      capitalizeFirstLetter(lang[languaje]['msgUserErrorData'])
    );
    localStorage.setItem("ErrorLogin", true);
    setMsgErrorLogin(
      capitalizeFirstLetter(lang[languaje]['msgUserErrorData'])
    );
  }
}, []);
  const getPermisos = (rol_id) => {
 
    // setDataPermisos({ data: dataPermisos.data, loading: true, error: "" });
    const fetchDataPost = async () => {
      try {
       
        const response = await fetch(
          server.url +
            "/api/v1/cassia/users/roles/" +
            rol_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
       
        if (response.ok) {
          const data1 = await response.json();
   
          setUserPermissions(data1.data.permissions);
          // setDataPermisos({ data: data1, loading: false, error: "" });
        } else {
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        // setDataPermisos({ data: dataPermisos.data, loading: false, error: "" });
       
      }
    };

    fetchDataPost();
  };

  const [timeRefresh, setTimeRefresh] = useState(2);

  const [autoRefresh,setAutoRefresh]=useState(false)
  const handleChangeRefresh = (e) => {
setTimeRefresh(e.target.value)
};
  useEffect(()=>{
    // console.log("problem loading-------------------------------------------------------------------"+dataProblems.loading)
    if(todoListnfo.loading==false){
      setAutoRefresh(true)
      // console.log("solo ejecutar aqu-------------------------------------------------------------------"+autoRefresh)
   

    }
  },[todoListnfo.loading])
  useEffect(()=>{
    if(autoRefresh){
      setTimeout(search_problems, (60000*timeRefresh));
    }
  },[autoRefresh])
  useEffect(()=>{
   setAutoRefresh(false)
search_problems()
// handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),'Exepción cerrada correctamente','', true)
  },[])
  const orderByAtter = (attr) => {
  setAttrSelected(attr)
  if (dataList.length === 0) {
    return;
  }

  const sortedData = [...dataList].sort((a, b) => {
      if (orderAsc) {
        setOrderAsc(false)
          if (a[attr] > b[attr]) return 1;
          if (a[attr] < b[attr]) return -1;
      } else {
        setOrderAsc(true)
          if (a[attr] < b[attr]) return 1;
          if (a[attr] > b[attr]) return -1;
      }
      return 0
  });

  if (orderAsc) {} else {}

  // Actualizar estado o hacer lo que necesites con sortedData
  // setProblems(sortedData);
};
  const orderBy = (attr) => {
//     setAttrSelected(attr)
//     if (dataList.length === 0) {
//         console.log('No hay datos para ordenar');
//         return;
//     }

//     const sortedData = [...dataList].sort((a, b) => {
//         if (orderAsc) {
//           setOrderAsc(false)
//             if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return 1;
//             if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return -1;
//         } else {
//           setOrderAsc(true)
//             if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return 1;
//             if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return -1;
//         }
//         return 0;
//     });

//     if (orderAsc) {
//         console.log('Ascendente', sortedData);
//     } else {
//         console.log('Descendente', sortedData);
//     }

//     // Actualizar estado o hacer lo que necesites con sortedData
//     setProblems(sortedData);
};
  const [limitList, setLimitList] = useState(100);
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [poolRows,setPoolRows]=useState([])
  const [poolObjectRows,setPoolObjectRows]=useState([])
  const [filtraOrigen,setFiltraOrigen]=useState(true)
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
      setPoolObjectRows([])
    } else {
      setPoolRows(dataList.map(item => item.eventid))
      setPoolObjectRows(dataList)
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };

  const handleSelectChange = (e) => {
      setPageActual(1)
      setLimitList(e.target.value);setPageActual(1);
    };
  const [modalAddCorIsOpen, setAddCorIsOpen] = React.useState(false);
  function openModalAddCor() {
    setAddCorIsOpen(true);
  }

  function closeModalAddCor() {
    setPoolObjectRows([])
    setPoolRows([])
    setAllSelected(false)
    setAddCorIsOpen(false);
  }
  let currentController = null;
  function search_problems(){
    if (currentController) {
   currentController.abort();
 }
    // setLoaderMap(false)
    // setInternalError(false)
    // search_count_exceptions()
    // search_count_exceptions_city()
    // search_problems_errors()
    // console.log("autorefresh",autoRefresh)
    // if(!autoRefresh){
    setTodoListnfo({data:todoListnfo.data,loading:true,error:""})
    // }
    const controller = new AbortController();
    const fetchData = async () => {
      try {
        
          
    // console.log(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter)
        // const response = await fetch(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter, {     
        const response = await fetch(server.url+'/api/v1/cassia/user/to_do_events/get_events', {             
                            headers: {
                              'Content-Type': 'application/json',
                              Authorization: `Bearer ${token_item}`,
                            },
                          });
        if (response.ok) {
          const response_data = await response.json();
          // console.log(response_data)
          setAutoRefresh(false)
          setTodoListnfo({data:response_data.data,loading:false,error:""})
          // setLoaderMap(false)
          
        } else {
          const response_data = await response.json();
          // console.log(response_data)
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        // setInternalError(true)
        setTodoListnfo({data:[],loading:todoListnfo.loading,error:error})
        //console.error(error);
      }
    };
    fetchData();
    return () => {
      controller.abort(); // ✅ Cancelar la solicitud si el componente se desmonta
    };
  }
  const [loadingM,setLoadingM]=useState(false);
  const AddTodoLst=()=>{
           //  console.log(poolRows)
           //  console.log(todoListnfo.data.map((element)=>element.eventid))
           //  console.log(todoListnfo.data.map((element)=>element.eventid).filter((item) => !poolRows.includes(item)))
           // //  console.log(todoListUser.data.data.event_ids)
            const mergedArray = todoListnfo.data.map((element)=>element.eventid).filter((item) => !poolRows.includes(item));
           // //  console.log(mergedArray)
            setAutoRefresh(false)
             setLoadingM(true)
               const fetchDataPost = async () => {
               
              try {
                const response = await fetch(server.url+'/api/v1/cassia/user/to_do_events/', {
                  method: 'PUT',  
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                  },
                  body:JSON.stringify({
                    "event_ids": mergedArray
                  })
                });
                if (response.ok) {
                  
                  const data1 = await response.json();
                  setLoadingM(false)
                  // Manejo de la respuesta
                  // setData(data1)
                  setPoolRows([]);
                  setPoolObjectRows([])
                 search_problems()
                  handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),'eventos elmnados correctamente de lista personal ','', true)
                  // const url = window.location.origin + '/todoList';
                  // window.open(url, '_blank');
                  // setTimeout( window.open(url, '_blank'),2000)
                  
                  // console.log(data1);
                } else {
                  throw new Error('Error en la solicitud');
                }
              } catch (error) {
                   // Manejo de errores
                   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
                   // setError(error)
                   console.error(error);
                 }
               };
           
               fetchDataPost();
               
         }
  const [searchResults2, setSearchResults2] = useState([]);
  const [searchTerm2, setSearchTerm2] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [searchResult2, setSearchResult2] = useState(null);
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [data,setData]=useState([]);
  const [dataUsers, setDataUsers] = useState({
      data: [],
      loading: true,
      error: null,
    });
  const handleSearch = (query) => {
// Aquí puedes realizar la búsqueda usando el valor de 'query'
// Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
// setSearchResult(`Resultados para: ${query}`);
};
  return (
    // <>
    //   <div className='contMonitorMovil'>
    //     <Modal
    //             isOpen={ImportModalOpen}
    //             // isOpen={false}
    //             // onAfterOpen={afterOpenExeption}
    //             onRequestClose={closeImportModal}
    //             style={CreateCisModalStyles}
    //             contentLabel="Example Modal2"
    //             // shouldCloseOnOverlayClick={false}
    //           >
    //           <ModalResponseEncuesta
    //           server={server}
    //           suveryId={suveryId}
    //           closCreateCisModal={closeImportModal}
    //           languaje={languaje}
    //           mode={mode}
    //           handleShowPopup={handleShowPopup}
    //         ></ModalResponseEncuesta>
    //         </Modal>
    //         </div>  
    // </>
    <>
      <div className={"main"} style={{height:'100%',width:'100%',position:'absolute'}}>
 <div className='head-reportes' style={{height:'8%',justifyContent:'end'}}>
   
      
     
          </div>
 <div className='head-cis' style={{height:'12%'}}>
  <div className='title-cis' >
              <Search
                  searchResults={searchResults}
                  setSearchResults={setSearchResults}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  onSearch={handleSearch}
                  dataObject={dataList}
                  setDataObject={setDataUsers}
                  searchResult={searchResult}
                  setSearchResult={setSearchResult}
                  languaje={languaje}
                  titulo={'Busqueda General (ip / host / fecha / etc)...'}
                />
               
                
                 <div className={"cont-result-registers"+mode}  style={{width:'20%',left:'75%',position:'absolute'}}>
       <p style={{  textAlign: "center" }}>
                  &nbsp;
                  {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                    dataList.length +
                    ") " 
                    }
                </p> 
                
        </div>
        <div className={"cont-result-registers"+mode}  style={{width:'70%',left:'5%' ,bottom:'unset',position:'absolute'}}>
       <Search
                  searchResults={searchResults2}
                  setSearchResults={setSearchResults2}
                  searchTerm={searchTerm2}
                  setSearchTerm={setSearchTerm2}
                  onSearch={handleSearch}
                  dataObject={dataList}
                  setDataObject={setDataUsers}
                  searchResult={searchResult2}
                  setSearchResult={setSearchResult2}
                  languaje={languaje}
                  titulo={'Buscar Afiliación...'}
                  attr={'affiliation'}
                />
                
        </div>
      <div className={"cont-result-registers"+mode} style={{width:'20%',left:'75%' , display:'flex' ,bottom:'0px',position:'absolute',right:'5%',justifyContent:'space-between'}}>
       
                <div style={{  textAlign: "center",color:'var(--green)',height:'100%' }}>
                 
                  {'Resuelto'+" (" +
                    contResolved +
                    ") " 
                    }
                </div> 
                 <div style={{  textAlign: "center" ,color:'red',height:'100%' }}>
                 
                  {'Probelma'+" (" +
                    contProblem +
                    ") " 
                    }
                </div> 
        </div>
        
              </div>
              
          </div>
          <div className='cont-cis' style={{height:'80%'}}>
          <>
    <div className="main-panel-cis">
    <div className="compact-content-portafolio">
    <div className={"content-portafolio-head"+mode}>
      {
      // (contRowsSelected!=0)?
        <>
        {(false)?<div className="cont-excels-buttons-portafolio cont-result-registers"  style={{position:'absolute'}}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div>:
        <>
         <div className="cont-display-paginador" style={{width:'40%',left:'-30%'}}>
                    
                    <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {(loadingM)?'eliminando de lista personal ....':
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={(poolRows.length==0)?"actDisabled":" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{AddTodoLst()}} disabled={(poolRows.length==0)}>Elminar de  lista personal</button>
                              </div>
                              }
                    </div>
                     <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              {/* <button class={" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{OpenTodoLst()}} disabled={false}>ver  lista personal</button> */}
                              </div>
                              }
                    </div>
                  </div>
        {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
        <div className="cont-excels-buttons-portafolio" style={{position:'absolute',left:'50%',width:'30%'}}>
        
                               <div className="half-excels-buttons-portafolio">
                      {
                              <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={(poolRows.length==0)?"actDisabled":" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{openModalAddCor()}} disabled={(poolRows.length==0)}>+Evento Correlacionado</button>
                              </div>
                            }
                          
                    </div>
                    <div className="half-excels-buttons-portafolio">
                      
                           <div className='contBtnCorrelacion' style={{position:'absolute',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              {/* <button class=" actRed " style={{minHeight:'unset',height:'2vh',width:'12vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{openModalMasiveDelete()}}>Cierre Masivo</button> */}
                              </div>
                    </div>
                    </div>
                    <div className="cont-excels-buttons-portafolio" style={{position:'absolute'}}>
        <div className="half-excels-buttons-portafolio">
                      
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                //         <img
                //   className="img-dwnld-portafolio"
                //   src={"/iconos/csv_icon.png"}
                //   name="regresar"
                //   onClick={()=>Exportar('csv')}
                //   style={{opacity:(contRowsSelected==0)? '0.3':'1',
                //     pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                // />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'CSV  '}
                      </div>
                    </div>
                   <div className="half-excels-buttons-portafolio">
                      
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                //         <img
                //   className="img-dwnld-portafolio"
                //   src={"/iconos/json_icon.png"}
                //   name="regresar"
                //   onClick={()=>Exportar('json')}
                //   style={{opacity:(contRowsSelected==0)? '0.3':'1',
                //     pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                // />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'JSON'}
                      </div>
                    </div>
                    <div className="half-excels-buttons-portafolio">
                    
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                //         <img
                //   className="img-dwnld-portafolio"
                //   src={"/iconos/xsl_icon.png"}
                //   name="regresar"
                //   onClick={()=>Exportar('excel')}
                //   style={{opacity:(contRowsSelected==0)? '0.3':'1',
                //     pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                // />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                      {'EXCEL'}
                      </div>
                    </div>
               </div>
         </>
        }
        </>
        // :''
            }
            </div>
      <div className="content-portafolio">
        <div className="cont-portafolio-table">
          <div className="content-card-portafolio" id="content">
            {(false ) ? (
              <LoadSimple />
            ) : (
              <>
                
                  <TableEvents
                    pageActual={pageActual}
                     limitList={limitList} startLimit={startLimit}
                    dataList={dataList}
                    // cisSelected={cisSelected}
                    // setCisSelected={setCisSelected}
                    // registerIsValid={registerIsValid}
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    dataUsers={dataUsers}
                    setDataUsers={setDataUsers}
                    server={server}
                    // setRegisterIsValid={setRegisterIsValid}
                    setData={setData}
                    // setLoading={setLoading}
                    // setError={setError}
                    // handleChangEdit={handleChangEdit}
                    // devices={devices}
                    languaje={languaje}
                    mode={mode}
                    setContRowSelected={setContRowSelected}
                    poolRows={poolRows}
                    setPoolRows={setPoolRows}
                    allSelected={allSelected}
                    setAllSelected={setAllSelected}
                   setPoolObjectRows={setPoolObjectRows}
                    handleShowPopup={handleShowPopup}
                    // setImportModalOpen={setImportModalOpen}
                    //  setSuveryId={setSuveryId} 
                    //   ubiActual={ubiActual} 
                      // search_problems={search_problems}
                      userPermissions={userPermissions}
                       dataAgencies={dataAgencies}
                       origen={'to-do'}
                  ></TableEvents>
                
              </>
            )}
          </div>
        </div>

        </div>
        <div className={"content-portafolio-footer"+mode}>
          {/* <div className="cont-display-paginador" style={{width:'40%'}}>
                    <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {(loadingM)?'agregando a lista personal ....':
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={(poolRows.length==0)?"actDisabled":" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{AddTodoLst()}} disabled={(poolRows.length==0)}>Agregar a lista personal</button>
                              </div>
                              }
                    </div>
                     <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{OpenTodoLst()}} disabled={false}>ver  lista personal</button>
                              </div>
                              }
                    </div>
                  </div> */}
        <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
          
          <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                    </p> 
                
          </div>
        </div>  
        <div className="cont-display-paginador">
                  <Paginador  pages={pages}
                              pageActual={pageActual}
                              setPageActual={setPageActual}
                              mode={mode}></Paginador>
        </div>
        <div className="cont-display-paginador">
          <div className={"cont-half-display-paginador"+mode}>
                    
          <div>
    <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
    <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
      <option value={10}>10</option>
      <option value={50} >50</option>
      <option value={100}>100</option>
      <option value={500}>500</option>
      <option value={1000}>1000</option>
    </select>

    
  </div>
          </div>
          <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                        ?  parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']}
                    </p>
                
          </div>
        </div>  
                  
      </div>
      </div>
    </div>
    {/* <Modal
            isOpen={modalAddCorIsOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModalAddCor}
            style={addHostModalStyles}
            contentLabel="Example Modal"
          >
           <ModalAddProblem editActive={false} poolObjectRows={poolObjectRows} setPoolObjectRows={setPoolObjectRows} poolRows={poolRows} server={server} handleShowPopup={handleShowPopup}  setPoolRows={setPoolRows} languaje={languaje}  mode={mode} closeAddHostModal={closeModalAddCor} />
          </Modal>
          <Modal
      isOpen={modalMasiveDeleteIsOpen}
      // onAfterOpen={afterOpenModal}
      onRequestClose={closeModalMasiveDelete}
      style={MasiveDeleteModalStyles}
      contentLabel="Example Modal"
    >
     <ModalMasiveDelete  server={server} handleShowPopup={handleShowPopup}   languaje={languaje}  mode={mode} closeModalMasiveDelete={closeModalMasiveDelete} />
    </Modal> */}

  {/* <Modal
      isOpen={ImportModalOpen}
      // isOpen={false}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closeImportModal}
      style={ImportModalStyles}
      contentLabel="Example Modal2"
      shouldCloseOnOverlayClick={false}
    >
    <ImportInfo
    server={server}
    importLoading={importLoading}
    setImportLoading={setImportLoading}
    closeImportModal={closeImportModal}
    languaje={languaje}
    mode={mode}
    handleShowPopup={handleShowPopup}
  ></ImportInfo>
  </Modal> */}
  </>
              
          </div>
          </div>
    </>
  );
};

export default TodoList;
